import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';

import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';
import { TranslateDirective } from '../../../../directives/translate.directive';

import { BaryComponentHelper } from '../../util/bary-component-helper';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-input-text',
  templateUrl: './bary-input-text.component.html',
  styleUrls: ['./bary-input-text.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputUtilitiesModule, InputsModule, MDBBootstrapModulesPro, MarkAsteriskDirective, TranslateDirective, BaryIconComponent],
})
export class BaryInputTextComponent implements OnInit {
  @Input() id = '';
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() icon?: string;
  @Input() disabled = false;
  @Input() control = new FormControl('');
  @Input() loading = false;
  @Input() messageError = '';
  @Input() validators = [Validators.pattern('[^|]*')];
  @Input() maxlength: number = 250; // technical limit (varchar 255)

  protected readonly FAR = FaDirectiveEnum.FAR;

  public ngOnInit(): void {
    this.id = this.id ? this.id : BaryComponentHelper.makeId();
    this.control.addValidators(this.validators);
  }

  get value(): string {
    return this.control.value ?? '';
  }
}
